/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Grid, Surface, Text } from '@zapier/design-system';

import Styles from './Styles';
import { isErrorEvent, isBundleEvent, isConsoleEvent } from '../utils';
import {
  BundleDetails,
  ConsoleDetails,
  ErrorDetails,
  GeneralBlock,
  ResponseDetails,
  RequestDetails,
} from './Details';

import type { EventType } from '../types';

type Props = {
  event: EventType;
};

function RowDetails({ event }: Props) {
  return (
    <section css={Styles.rowDetails}>
      <Surface borderColor="GrayWarm4">
        <div css={Styles.details}>
          <Grid columns={1} gap={10}>
            <Text tag="h3" type="SectionHeader">
              Event details
            </Text>
            <GeneralBlock event={event} />
            {isErrorEvent(event) && <ErrorDetails event={event} />}
            {isConsoleEvent(event) && <ConsoleDetails event={event} />}
            {isBundleEvent(event) && <BundleDetails event={event} />}
            <RequestDetails event={event} />
            <ResponseDetails event={event} />
          </Grid>
        </div>
      </Surface>
    </section>
  );
}

export default RowDetails;
